import { type PropsWithChildren, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { appConfig } from "../config";
import { ConsentBanner } from "./ConsentBanner";

export function AppFrame({ children }: PropsWithChildren) {
  const location = useLocation();
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="app-frame">
      {!online ? (
        <div className="network-banner" role="status">
          Você está sem conexão. Suas respostas ficam salvas neste dispositivo e serão sincronizadas quando a conexão voltar.
        </div>
      ) : null}
      {children}
      {appConfig.analyticsConsentRequired || appConfig.marketingConsentRequired
        ? <ConsentBanner />
        : null}
    </div>
  );
}
